import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from '../i18n/zh_CN';
import en from '../i18n/en_US';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem('locale'),
  messages: {
    zh,
    en
  }
});

export default i18n;
